import React__default from 'react';
import { KpkAttachmentMetaType, KpkAttachmentMetaDateType, dayjs } from '@keepeek/commons';
import { Typography } from '@mui/material';
import clsx from 'clsx';

// ATTENTION: This should stay a Functional Component
// Because we're using it as a function for rendering evaluation
var AttachmentMeta = function (_a) {
    var meta = _a.meta;
    switch (meta.type) {
        case KpkAttachmentMetaType.Date:
            if (meta.dateType === KpkAttachmentMetaDateType.Created) {
                return (React__default.createElement(Typography, { className: clsx("AttachmentMeta", "AttachmentMeta-".concat(meta.type)), "data-testid": "AttachmentMeta-".concat(meta.type), variant: "caption" }, dayjs(meta.date).format("LL")));
            }
            // We don't show the update date
            return null;
        case KpkAttachmentMetaType.Size:
            return (React__default.createElement(Typography, { className: clsx("AttachmentMeta", "AttachmentMeta-".concat(meta.type)), "data-testid": "AttachmentMeta-".concat(meta.type), variant: "caption" },
                meta.size,
                "\u00A0",
                React__default.createElement("small", null, meta.unit)));
        default:
            return null;
    }
};

export { AttachmentMeta as default };
//# sourceMappingURL=AttachmentMeta.js.map
